import c from './assets/sass/container.module.scss'

export const Container = ({ children }) => {
    return <div className={c.component}>{children}</div>
}
